import React from 'react';
import { ProductExportConfiguration } from '../types/product_export_configuration/productExportConfiguration';

export interface ProductExportConfigurationContextProps {
  productExportConfigurations: Map<string, ProductExportConfiguration>;
  setProductExportConfigurations: (productMasterData: Map<string, ProductExportConfiguration>) => void;
  productExportConfigurationsLoading: boolean;
}

const defaultContext: ProductExportConfigurationContextProps = {
  productExportConfigurations: new Map(),
  setProductExportConfigurations: () => {},
  productExportConfigurationsLoading: false,
};

export const ProductExportConfigurationContext =
  React.createContext<ProductExportConfigurationContextProps>(defaultContext);
